import base from './components/base.vue';


export default {
  routes: [
    {
      path: '/',
      component:base,
      name:'base'
    },
  ]
}
